import { useEffect, useState } from 'react'
import CreateJobInput from '../CreateJob/CreateJobInput'
import AxiosInstance from 'utils/AxiosInstance'
import { useDispatch } from 'react-redux'
import { setCurrentSetupSystemData } from 'store/Recruitment/actions'
import { useSelector } from 'react-redux'

function CreateScreeningIndicator({ generalId }) {
  const dispatch = useDispatch()
  const { currentSystemSetupData, editingSystemSetup } = useSelector(
    (store) => store.recruitment
  )

  const [options, setOptions] = useState([])

  useEffect(() => {
    AxiosInstance.get(`/recruitment/setup/screening_type`).then((data) => {
      setOptions(
        data.map((el) => {
          return { name: el.value, value: el.value, id: el.id }
        })
      )
    })
  }, [])

  const selectDropdown = Array.isArray(currentSystemSetupData)
    ? currentSystemSetupData?.find((el) => el.field === 'screeningType')
    : undefined

  const name = Array.isArray(currentSystemSetupData)
    ? currentSystemSetupData?.find((el) => el?.field === 'name')?.value
    : ''

  return (
    <>
      <CreateJobInput
        id='createScreeningIndicator'
        placeholder='Enter Name'
        label='Name'
        required={true}
        fullSize={false}
        defaultValue={name}
        onChange={(value, required) =>
          dispatch(
            setCurrentSetupSystemData({
              generalId: !editingSystemSetup
                ? generalId
                : currentSystemSetupData[0].generalId,
              field: 'name',
              value,
              required,
            })
          )
        }
      />
      <CreateJobInput
        id='screeningType'
        placeholder='Select Screening Type'
        label='Screening Type'
        required={true}
        fullSize={false}
        select={true}
        options={options}
        onChange={(value, required) => {
          dispatch(
            setCurrentSetupSystemData({
              generalId: !editingSystemSetup
                ? generalId
                : currentSystemSetupData[0].generalId,
              field: 'screeningType',
              value: value?.value,
              screeningTypeId: value?.option?.id,
              required,
            })
          )
        }}
        selectedOptions={
          selectDropdown?.value
            ? { name: selectDropdown.value, value: selectDropdown.value }
            : []
        }
      />
    </>
  )
}

export default CreateScreeningIndicator
